import { ModelRow } from "@mcleod/core";
import { AutogenLayoutSettlementLeaveHistoryList } from "./autogen/AutogenLayoutSettlementLeaveHistoryList";
import { LookupModelSearchEvent, TableRowCreationEvent } from "@mcleod/components";



export class SettlementLeaveHistoryList extends AutogenLayoutSettlementLeaveHistoryList {

    override onLoad(): void | Promise<void> {
        this.mainDataSource.orderBy = [
            {field:"check_date", sort: "desc"},
            {field:"payee_id", sort: "asc"},
            {field:"applies_to", sort: "asc"},
            {field:"id", sort: "desc"}
        ];
        this.tableLeaveTransactions.addRowCreateListener((event: TableRowCreationEvent) => {
            const newRow = event.getTableRow();
            if (!newRow.data.isNull("balance_data")){
                const balanceRow = new ModelRow(this.tableLeaveTransactions.dataSource.url, false, newRow.data.get("balance_data"));
                this.tableLeaveTransactions.redisplaySingleRow(null, balanceRow, true, true);
                newRow.data.set("balance_data", undefined);
            }
        });
    }

    /** This is an event handler for the beforeLookupModelSearch event of textboxPayeeIdSearch. */
    textboxPayeeIdSearchBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.non_office_emp = "Y";
        event.filter["drs_payee.type_of"] = "C";
    }
}
